import { gql } from '__generated__'

export const GetDegreeTypes = gql(/* GraphQL */ `
    query GetDegreeTypes {
        degreeTypes {
            id
            value
        }
    }
`)
